import { useEffect, useMemo, useState } from 'react';

const getIsMobileApp = () =>
	typeof navigator !== 'undefined' && navigator.userAgent.includes('THDMXAPP');

/**
 * React hook for use by the presentation layer to read isMobileApp state
 * data.
 */
export const useMobileApp = () => {
	const isMobileApp = useMemo(() => getIsMobileApp(), []);
	const [isReady, setIsReady] = useState(false);
	useEffect(() => {
		// This runs only on the client side after the initial render pass
		setIsReady(true);
	}, []);
	return { isMobileApp: isReady ? isMobileApp : false, isLoading: !isReady };
};
